import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "manifold m-buy"
}
const _hoisted_2 = { key: 1 }

import { utils } from "ethers";
import { computed, reactive } from "vue";
import { SalePhase } from "@manifoldxyz/collectible-sdk";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";
import { EthereumProvider } from "@/EthereumProvider";
import ButtonComponent from "./ButtonComponent.vue";
import Claim from "./Claim.vue";
import CollectibleDialog from "./CollectibleDialog.vue";

interface BuyProps {
  showPrice?: boolean;
  asCarousel?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Buy',
  props: {
    showPrice: { type: Boolean },
    asCarousel: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const store = useStore();

const componentState = reactive<{
  isCollectibleOpen: boolean;
}>({ isCollectibleOpen: false });

const shouldRenderClaimButton = computed(() => {
  return [SalePhase.CLAIM, SalePhase.TO_CLAIM].includes(store.salePhase!);
});

const messaging = useMessaging();
const buttonText = computed(() => {
  let text = messaging.BUY_BUTTON_CTA;

  if (!store.saleHasStarted) {
    text = messaging.BUY_BUTTON_SALE_NOT_STARTED;
  }
  if (store.saleIsFinalized) {
    text = messaging.BUY_BUTTON_SOLD_OUT;
  }
  if (store.saleHasEnded) {
    text = messaging.BUY_BUTTON_SALE_ENDED;
  }

  if (store.saleIsActive) {
    const notEnoughEthMessage = () => {
      return `${messaging.BUY_BUTTON_NOT_ENOUGH_ETH} (Requires ${utils.formatUnits(
        store.price!.toString(),
        "ether"
      )} ETH)`;
    };

    if (store.salePhase === SalePhase.PRESALE) {
      if (!store.walletAddress && !store.crossmintClientId) {
        text = messaging.BUY_BUTTON_CONNECT_WALLET_TO_BUY;
      } else if (store.presaleEligibility?.isEligibleForPresale) {
        text = messaging.BUY_BUTTON_PRESALE_ELIGIBILITY;

        if (!store.userHasEnoughForPurchase) {
          text = notEnoughEthMessage();
        } else if (store.purchaseableAmount! < 1) {
          text = messaging.BUY_BUTTON_PRESALE_ALREADY_MINTED;
        }
      } else if (store.isFetchingPresaleEligibility) {
        text = messaging.BUY_BUTTON_CHECKING_ELIGIBILITY;
      } else {
        text = messaging.BUY_BUTTON_PRESALE_INELIGIBILITY;
      }
    } else {
      if (store.purchaseableAmount! < 1) {
        text = messaging.BUY_BUTTON_PURCHASE_LIMIT_REACHED;
      } else if (!store.walletAddress && !store.crossmintClientId) {
        text = messaging.BUY_BUTTON_CONNECT_WALLET_TO_BUY;
      } else if (!store.userHasEnoughForPurchase) {
        text = notEnoughEthMessage();
      }
    }
  }

  if (text === messaging.BUY_BUTTON_CTA) {
    if (props.showPrice) {
      text = `${text} ${utils.formatUnits(store.price!, "ether")}ETH`;
    }
  }

  return text;
});

const connect = async (): Promise<void> => {
  if (EthereumProvider.hasBrowserProvider()) {
    await EthereumProvider.connect();
  }
};

const onOpen = () => {
  componentState.isCollectibleOpen = true;
};

const onClose = () => {
  componentState.isCollectibleOpen = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(store).loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (shouldRenderClaimButton.value)
            ? (_openBlock(), _createBlock(Claim, {
                key: 0,
                "as-carousel": props.asCarousel,
                onConnect: connect
              }, null, 8, ["as-carousel"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_unref(store).walletAddress || _unref(store).crossmintClientId)
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      class: "m-buy-button",
                      "is-disabled": !_unref(store).userCanPurchase,
                      "is-loading": _unref(store).isFetchingPresaleEligibility,
                      onClick: onOpen
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(buttonText.value), 1)
                      ]),
                      _: 1
                    }, 8, ["is-disabled", "is-loading"]))
                  : (_openBlock(), _createBlock(ButtonComponent, {
                      key: 1,
                      class: "m-buy-button",
                      "is-disabled": _unref(store).saleHasEnded,
                      onClick: connect
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(buttonText.value), 1)
                      ]),
                      _: 1
                    }, 8, ["is-disabled"])),
                (componentState.isCollectibleOpen)
                  ? (_openBlock(), _createBlock(CollectibleDialog, {
                      key: 2,
                      class: "m-buy-collectible-modal",
                      "as-carousel": props.asCarousel,
                      onClose: onClose
                    }, null, 8, ["as-carousel"]))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})